/**
 * @module mapbs.components.reportpanel.egtarea.egtarea
 */

import angular from 'angular';
import olInteractionDraw from 'ol/interaction/Draw.js';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import olFormatWFS from 'ol/format/WFS.js';
import * as olFormatFilter from 'ol/format/filter.js';

const moduleEgtarea = angular.module('mapbsEgtareaModule', []);

moduleEgtarea.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/egtarea', require('./egtarea.html'));
    }
);

/**
 * @type {!angular.Component}
 */
const egtarea = {
    controller: 'mapbsEgtareaController as ctrl',
    templateUrl: () => 'mapbs/egtarea',
    bindings: {
        'map': '<mapbsEgtareaMap',
        'reportPanelActive': '<mapbsEgtareaActive',
    },
};

moduleEgtarea.component('mapbsEgtarea', egtarea);

class EgtareaController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$injector} $injector
   * @param {angular.$http} $http
   * @param {ngeox.QueryResult} ngeoQueryResult The ngeo query result service.
   * @param {ngeo.ToolActivateMgr} ngeoToolActivateMgr
   * @private
   * @ngInject
   */
    constructor($scope, $injector, $http, ngeoQueryResult, ngeoToolActivateMgr) {
        this.scope = $scope;
        this.injector = $injector;
        this.http = $http;

        /** @type {string} */
        this.state = 'inactive';

        /** @type {string} */
        this.nodata;

        /** @type {!olGeomGeometry} */
        this.querygeom;

        /** @type {boolean} */
        this.reportPanelActive;

        /**@type {string} @private */
        this.egtareaproxy = $injector.get('ngeoEgtAreaProxy');

        /** @type {boolean} */
        this.mapInteractionActive = false;

        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'mapInteractionActive'),
            false
        );
        this.egtareaDrawInteraction = new olInteractionDraw({
            type: /** @type{import("ol/geom/GeometryType.js")} */ ('Polygon'),
        });

        this.egtareaDrawInteraction.on('drawend', (event) => {
            this.querygeom = event.feature.getGeometry();
            this.queryFeature();
        });

        this.result_ = ngeoQueryResult;

        this.scope.$on('tookfocus', (event, name) => {
            if (name !== 'egtarea') {
                this.setState('inactive');
            }
        });

        this.scope.$watch(
            () => {
                return this.reportPanelActive;
            },
            (newVal) => {
                if (!newVal) {
                    this.setState('inactive');
                }
            }
        );
    }

    /**
   * sets state of component
   * @param {string} state
   * @private
   */
    setState(state) {
        this.map.removeInteraction(this.egtareaDrawInteraction);
        switch (state) {
            case 'active':
                this.map.addInteraction(this.egtareaDrawInteraction);
                this.mapInteractionActive = true;
                this.scope.$emit('takefocus', 'egtarea');
                break;
        }
        this.state = state;
    }

    /**
   * toggle state of component from 'active' to 'inactive' and vice versa
   */
    togglestate() {
        if (this.state === 'inactive') {
            this.setState('active');
        } else if (this.state === 'active') {
            this.setState('inactive');
            this.nodata = '';
        }
    }

    /**
   * queries freature at server
   * @private
   */
    queryFeature() {
        this.setState('wait');
        this.nodata = '';

        const featureRequest = new olFormatWFS().writeGetFeature({
            featurePrefix: 'osm',
            featureNS: 'https://map.geo.bs.ch',
            featureTypes: ['EG_Eigentuemerauskunft_Eigentuemer'],
            filter: olFormatFilter.intersects(
                'the_geom',
                /** @type {!olGeomGeometry} */ (this.querygeom),
                'EPSG:2056'
            ),
        });

        const body = new XMLSerializer().serializeToString(featureRequest);
        const params = {};
        this.http
      .post(this.egtareaproxy, body, {
          params,
          headers: {'Content-Type': 'text/xml; charset=UTF-8'},
      })
      .then((response) => {
          if (response.data === 'Zu viele Resultate!') {
              this.setState('active');
              this.nodata =
            'Zu viele Resultate, bitte einen kleineren Ausschnitt wählen';
          } else {
              const featresult = new olFormatWFS().readFeatures(response.data);
              this.handleFeatureRequestSuccess(featresult);
          }
          this.mapInteractionActive = false;
      });
    }

    handleFeatureRequestSuccess(featresult) {
        this.setState('active');
        if (featresult.length === 0) {
            this.nodata = 'Keine Daten gefunden';
            return;
        }

        this.result_.sources.push({
            features: featresult,
            id: 1,
            label: 'Eigentumsauskunft',
            limit: 37,
            pending: false,
            queried: true,
            tooManyResults: false,
            toaltFEatureCount: featresult.length,
        });

        this.result_.total = featresult.length;
        this.result_.pending = false;
        this.setState('inactive');
    }
}

moduleEgtarea.controller('mapbsEgtareaController', EgtareaController);

export default moduleEgtarea;
